export default function Footer() {
  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-b from-orange-100 to-orange-200 pt-16 pb-8 border-t-4 border-orange-400" style={{ borderStyle: 'dashed' }}>
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-14 h-14 bg-gradient-to-br from-orange-400 to-red-400 rounded-full flex items-center justify-center shadow-lg" style={{
                border: '3px dashed white'
              }}>
                <i className="ri-restaurant-2-line text-white text-2xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-800" style={{ fontFamily: '"Klee One", cursive' }}>
                  シルバー料理教室
                </h3>
                <p className="text-sm text-orange-700" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
                  合同会社シルバー
                </p>
              </div>
            </div>
            <p className="text-gray-700 mb-4 leading-relaxed" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
              料理の楽しさを、もっと身近に。<br />
              初心者から上級者まで、みんなが笑顔になれる料理教室です。
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold text-gray-800 mb-4" style={{ fontFamily: '"Klee One", cursive' }}>
              メニュー
            </h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer text-left"
                  style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
                >
                  レッスン内容
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('features')}
                  className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer text-left"
                  style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
                >
                  特徴
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('gallery')}
                  className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer text-left"
                  style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
                >
                  ギャラリー
                </button>
              </li>
              <li>
                <a
                  href="/privacy"
                  className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer text-left"
                  style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
                >
                  プライバシーポリシー
                </a>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer text-left"
                  style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
                >
                  お問い合わせ
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold text-gray-800 mb-4" style={{ fontFamily: '"Klee One", cursive' }}>
              アクセス
            </h4>
            <ul className="space-y-3 text-gray-700" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-orange-600 mt-1 flex-shrink-0"></i>
                <span className="text-sm">
                  〒410-0822<br />
                  静岡県沼津市下香貫楊原670番地<br />
                  ドルチェヴィータ北館305
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t-2 border-orange-300 pt-8 text-center" style={{ borderStyle: 'dashed' }}>
          <p className="text-gray-600 text-sm" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
            &copy; 2024 合同会社シルバー. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
